export default __webpack_public_path__ + "static/header-top-mobile-e79536c4d42cbbab5587fb54a75850c3.svg";